
import { useState } from 'react';
import emailjs from '@emailjs/browser';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import designerThoughtImg from '../../assets/img/design-expert.png';
import './style.css';

const ADMIN_EMAIL = 'michaelozor15@gmail.com';

const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID as string || 'service_xbhzgll';
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID as string || 'template_x94tztf';
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY as string   || 'FfxOtddg-vmzkGyJ4';

type FormState = {
    fullName: string
    email: string
    phone: string
    message: string
}

type SubmitStatus = 'idle' | 'sending' | 'success' | 'error'

const initialFormState: FormState = {
    fullName: '',
    email: '',
    phone: '',
    message: '',
}

const ReachOutComp = () => {
    const [form, setForm] = useState<FormState>(initialFormState)
    const [status, setStatus] = useState<SubmitStatus>('idle')

    const isFormValid = Object.values(form).every((value) => value.trim().length > 0)
    const isDisabled = !isFormValid || status === 'sending'

    const handleChange = (field: keyof FormState) => (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setForm((prev) => ({ ...prev, [field]: e.target.value }))
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (isDisabled) return

        setStatus('sending')

        try {
            await emailjs.send(
                EMAILJS_SERVICE_ID,
                EMAILJS_TEMPLATE_ID,
                {
                    to_email: ADMIN_EMAIL,
                    full_name: form.fullName,
                    from_email: form.email,
                    phone: form.phone,
                    message: form.message,
                },
                { publicKey: EMAILJS_PUBLIC_KEY }
            )
            setStatus('success')
            setForm(initialFormState)
        } catch (error) {
            setStatus('error')
        }
    }

    return(
        <>
            <div className='reach-out w-full bg-white mt-40 mb-20'>
                <div className="mx-auto lg:w-11/12">
                    <div className="reach-out-flex flex gap-32 flex-wrap content-between">
                        <div className="designer-thoughts lg:w-2/5">
                            <img className='mb-10' src={designerThoughtImg} alt="" />

                            <h2 className="main-header mb-10 font-semibold text-5xl">Talk to a Design Expert</h2>
                            <p className="paragragh paragraph1 mb-4 text-base">
                                Design is not just about making things look good; 
                                it's about creating impactful solutions that communicate messages, 
                                evoke emotions, and inspire action. At Blake’s Design Studio, 
                                We strive to bring your ideas to life, breathing beauty and functionality into every project.
                            </p>
                            <p className="paragragh paragraph2">
                                What sets us apart is our unwavering commitment to delivering exceptional results. 
                                With a blend of creativity and technical expertise, we approach each design challenge 
                                as an opportunity to push boundaries and surpass expectations.
                            </p>
                        </div>

                        <form className="form lg:w-2/5" onSubmit={handleSubmit}>
                            <div className="formcontrol mb-5">
                                <label className='mb-5 block text-base' htmlFor="fullName">Full Name or company name</label>
                                <input
                                    id="fullName"
                                    className='py-3 px-8 border border-gray-400 rounded-md w-full focus:outline-none'
                                    type="text"
                                    placeholder='enter your full name'
                                    value={form.fullName}
                                    onChange={handleChange('fullName')}
                                    required
                                    disabled={status === 'sending'}
                                />
                            </div>

                            <div className="formcontrol mb-5">
                                <label className='mb-5 block text-base' htmlFor="email">Email Address</label>
                                <input
                                    id="email"
                                    className='py-3 px-8 border border-gray-400 rounded-md w-full focus:outline-none'
                                    type="email"
                                    placeholder='enter your email'
                                    value={form.email}
                                    onChange={handleChange('email')}
                                    required
                                    disabled={status === 'sending'}
                                />
                            </div>

                            <div className="formcontrol mb-5">
                                <label className='mb-5 block text-base' htmlFor="phone">Phone Number (whatsapp Number preferably)</label>
                                <input
                                    id="phone"
                                    className='py-3 px-8 border border-gray-400 rounded-md w-full focus:outline-none'
                                    type="text"
                                    placeholder='whatsapp number'
                                    value={form.phone}
                                    onChange={handleChange('phone')}
                                    required
                                    disabled={status === 'sending'}
                                />
                            </div>

                            <div className="formcontrol mb-5">
                                <label className='mb-5 block text-base' htmlFor="message">what do you want?</label>
                                <textarea
                                    id="message"
                                    rows={6}
                                    className='block py-3 px-8 border border-gray-400 rounded-md w-full focus:outline-none'
                                    placeholder='text'
                                    value={form.message}
                                    onChange={handleChange('message')}
                                    required
                                    disabled={status === 'sending'}
                                />
                            </div>

                            <div className="flex items-center justify-end gap-4">
                                {status === 'success' && (
                                    <p className="text-green-600 text-sm">Thanks! We'll be in touch shortly.</p>
                                )}
                                {status === 'error' && (
                                    <p className="text-red-600 text-sm">Something went wrong. Please try again.</p>
                                )}

                                <button
                                    type="submit"
                                    disabled={isDisabled}
                                    className={`button flex items-center gap-2 text-white font-semibold text-xl py-2 mt-7 px-12 rounded-md
                                        ${isDisabled ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-900'}`}
                                >
                                    {status === 'sending' && (
                                        <AiOutlineLoading3Quarters className='animate-spin' />
                                    )}
                                    {status === 'sending' ? 'Sending...' : 'Submit'}
                                </button>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReachOutComp
